<!--  -->
<template>
  <div>
    <el-form
      ref="formRef"
      label-position="right"
      label-width="100px"
      :rules="rules"
      :model="formLabelAlign"
    >
      <el-form-item label="IP" prop="address">
        <el-input
          v-model="formLabelAlign.address"
          placeholder="请输入IP地址"
        />
      </el-form-item>
      <el-form-item label="端口" prop="port">
        <el-input
          v-model="formLabelAlign.port"
          placeholder="请输入端口"
        />
      </el-form-item>
      <el-form-item label="账户" prop="account">
        <el-input
          v-model="formLabelAlign.account"
          placeholder="请输入账户"
        />
      </el-form-item>
      <el-form-item label="pwd" prop="pwd">
        <el-input
          v-model="formLabelAlign.pwd"
          placeholder="请输入pwd"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbit"
        >确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { proxyConfigCreate, proxyConfigUpd } from '@/api/officialaccount.js'
export default {
  components: {},
  data() {
    return {
      formLabelAlign: {
        address: '',
        account: '',
        port: '',
        pwd: ''
      },
      type: null,
      id: null,
      rules: {
        address: [
          { required: true, message: '请输入IP地址', trigger: 'blur' }
        ],
        port: [
          { required: true, message: '请输入端口', trigger: 'blur' }
        ],
        account: [
          { required: true, message: '请输入账户', trigger: 'blur' }
        ],
        pwd: [
          { required: true, message: '请输入pwd', trigger: 'blur' }
        ]
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    send(type, item) {
      if (type === 1) {
        this.type = type
      } else {
        this.type = type
        this.id = item.id
        this.formLabelAlign.address = item.address
        this.formLabelAlign.port = item.port
        this.formLabelAlign.account = item.account
        this.formLabelAlign.pwd = item.pwd
      }
    },
    async sumbit() {
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          if (this.type === 1) {
            const data = await proxyConfigCreate(this.formLabelAlign)
            console.log('data', data)
            this.$emit('updata')
          } else {
            const data = await proxyConfigUpd({
              ...this.formLabelAlign,
              id: this.id
            })
            console.log('data', data)
            this.$emit('updata')
          }
        } else {
          this.$message.error('请先填写完整表单 ❌')
          return false
        }
      })
    },
    resetForm() {
      this.$refs.formRef.resetFields()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
